import { useState, useEffect, useCallback } from "react";

const CONSENT_KEY = "bc_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
  }, []);

  const decline = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 border-t bg-white p-4 shadow-lg dark:border-gray-700 dark:bg-gray-900 sm:flex sm:items-center sm:justify-between sm:gap-4 sm:px-6"
    >
      <p className="text-sm text-gray-700 dark:text-gray-300">
        We use essential cookies to keep you signed in and remember your
        preferences. By continuing to use BidConvey you agree to our{" "}
        <a href="/privacy" className="underline font-medium">
          Privacy Policy
        </a>{" "}
        and{" "}
        <a href="/terms" className="underline font-medium">
          Terms of Service
        </a>
        .
      </p>
      <div className="mt-3 flex gap-2 sm:mt-0 sm:shrink-0">
        <button
          onClick={decline}
          className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
        >
          Decline
        </button>
        <button
          onClick={accept}
          className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
        >
          Accept
        </button>
      </div>
    </div>
  );
}
